import React from "react";
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import DeleteIcon from "@material-ui/icons/Delete";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

class TagsReporte extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos:[]
        }
    }

    componentDidMount() {
        this.setState({datos: this.props.datos})
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({datos: nextProps.datos})
    }

    deleteItems = (rowData) => {
        this.props.eliminarTag(rowData)
    };

    deleteAllItems = () => {
        this.props.limpiarTag()
    };


    render() {
        return(
            <MaterialTable
                localization={{
                    toolbar: {
                        searchPlaceholder: 'Buscar',
                    },
                    header: {
                        actions: 'Acciones'
                    },
                    body:{
                        emptyDataSourceMessage: 'No hay datos para mostrar'
                    }
                }}
                options={{
                    pageSize: 25,
                    pageSizeOptions: [10, 25, 50],
                    rowStyle: rowData => ({
                        backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                    }),
                    padding: "dense",
                    actionsColumnIndex: -1,
                    searchFieldStyle: {
                        width: "auto",
                    },
                    paginationType:"stepped"
                }}
                actions={[
                    {
                        icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                        tooltip: 'Eliminar tag de la lista',
                        onClick: (event, rowData) => this.deleteItems(rowData),
                    },
                ]}
                icons={tableicons}
                title=" "
                columns={[
                    { title: 'Tag', field: 'tag' },
                ]}
                data={this.state.datos}
                onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                components={{
                    Toolbar: props => (
                        <div>
                            <MTableToolbar {...props} />
                            <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                <Grid item>
                                    <Button variant="contained" name="delete" color="primary" onClick={this.deleteAllItems}>
                                    Limpiar tags</Button>
                                </Grid>
                            </Grid>
                        </div>
                    ),
                }}
            />
        )
    }
}

export default TagsReporte